module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout layout--one-screen bg-gray-lightest-5"
  }, [_c('div', {
    class: ['menu-backdrop d-xl-none', {
      'show': _vm.isOpenOnMinWin === false
    }],
    on: {
      "click": _vm.closeMenuOnMinWin
    }
  }), _vm._v(" "), (_vm.showMenuHead === '1' || _vm.showMenuHead === '3') ? _c('div', {
    class: ['layout-sidebar', {
      'layout-sidebar--folded': _vm.isOpen === false
    }, {
      'show': _vm.isOpenOnMinWin === false
    }]
  }, [_c('div', {
    staticClass: "layout-logo-left"
  }, [_vm._t("frame-header", [_c('span', [_c('img', {
    staticClass: "layout-logo-img",
    attrs: {
      "src": _vm.img,
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "layout-logo-min-img",
    attrs: {
      "src": _vm.imgMin,
      "alt": ""
    }
  })])]), _vm._v(" "), (_vm.showMenu) ? _c('a', {
    staticClass: "d-none d-xl-block thumb-icon",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('t-icon', {
    staticClass: "text-xxl text-black",
    attrs: {
      "type": "menu"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openOrClose($event)
      }
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
    class: ['layout-menu', {
      'menu--folded': _vm.isOpen === false
    }, {
      'menu--fold--show': _vm.clientWidth > 1200
    }, {
      'menu--fold--min': _vm.clientWidth <= 1199
    }]
  }, [_vm._t("frame-menu", [_c('t-menu', {
    ref: "sidebarMenu",
    class: [{
      'menu--folded': _vm.isOpen === false && _vm.clientWidth > 1200
    }],
    attrs: {
      "type": "light",
      "active-name": _vm.queryActiveMenu,
      "open-names": _vm.queryOpenName,
      "open-position": _vm.openPosition,
      "accordion": _vm.accordion
    },
    on: {
      "on-select": _vm.hdMenuClick
    }
  }, [_vm._l((_vm.treeData), function(item1, x) {
    return [(item1.children && item1.children.length) ? _c('t-submenu', {
      attrs: {
        "name": item1.menuName ? item1.menuName : ''
      }
    }, [_c('template', {
      slot: "title"
    }, [(item1.menuIcon) ? _c('t-icon', {
      attrs: {
        "type": item1.menuIcon
      }
    }) : _c('t-avatar', {
      attrs: {
        "size": "sm",
        "bg-state": "success",
        "text": item1.rightTag,
        "dot": false
      }
    }), _vm._v(" "), (item1.rightTag === _vm.tag && item1.menuUrl) ? _c('router-link', {
      attrs: {
        "to": {
          path: _vm.getRouterLinkUrl(item1.menuUrl)
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.useClickEvent(item1)
        }
      }
    }, [_c('span', {
      staticClass: "sub-text",
      attrs: {
        "title": _vm.lang === 'EN' ? item1.menuName : item1.menuEnName
      }
    }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item1.menuName : item1.menuEnName))])]) : (item1.systemUrl && item1.menuUrl && item1.rightTag !== _vm.tag) ? _c('a', {
      attrs: {
        "href": "javascript:;",
        "target": "_self"
      },
      on: {
        "click": function($event) {
          _vm.handleOtherRegin(item1.systemUrl + item1.menuUrl, item1)
        }
      }
    }, [_c('span', {
      staticClass: "sub-text",
      attrs: {
        "title": _vm.lang === 'EN' ? item1.menuName : item1.menuEnName
      }
    }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item1.menuName : item1.menuEnName))])]) : _c('span', {
      staticClass: "sub-text",
      attrs: {
        "title": _vm.lang === 'EN' ? item1.menuName : item1.menuEnName
      }
    }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item1.menuName : item1.menuEnName))])], 1), _vm._v(" "), _vm._l((item1.children), function(item2, y) {
      return [(item2.children && item2.children.length) ? _c('t-submenu', {
        staticClass: "second-submenu",
        attrs: {
          "name": item2.menuName ? item2.menuName : ''
        }
      }, [_c('template', {
        slot: "title"
      }, [(item2.rightTag === _vm.tag && item2.menuUrl) ? _c('router-link', {
        attrs: {
          "to": {
            path: _vm.getRouterLinkUrl(item2.menuUrl)
          }
        },
        nativeOn: {
          "click": function($event) {
            _vm.useClickEvent(item2)
          }
        }
      }, [_c('span', {
        staticClass: "sub-text",
        attrs: {
          "title": _vm.lang === 'EN' ? item2.menuName : item2.menuEnName
        }
      }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item2.menuName : item2.menuEnName))])]) : (item2.systemUrl && item2.menuUrl && item2.rightTag !== _vm.tag) ? _c('a', {
        attrs: {
          "href": "javascript:;",
          "target": "_self"
        },
        on: {
          "click": function($event) {
            _vm.handleOtherRegin(item2.systemUrl + item2.menuUrl, item2)
          }
        }
      }, [_c('span', {
        staticClass: "sub-text",
        attrs: {
          "title": _vm.lang === 'EN' ? item2.menuName : item2.menuEnName
        }
      }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item2.menuName : item2.menuEnName))])]) : _c('span', {
        staticClass: "sub-text",
        attrs: {
          "title": _vm.lang === 'EN' ? item2.menuName : item2.menuEnName
        },
        on: {
          "click": function($event) {
            _vm.useClickEvent(item2)
          }
        }
      }, [_vm._v(_vm._s(_vm.lang === 'ZH' ? item2.menuName : item2.menuEnName))])], 1), _vm._v(" "), _vm._l((item2.children), function(item3, z) {
        return [(item3.children && item3.children.length) ? _c('t-submenu', {
          staticClass: "second-submenu",
          attrs: {
            "name": item3.menuName ? item3.menuName : '',
            "id": x + '' + y
          }
        }, _vm._l((item3.children), function(item4, w) {
          return _c('t-menu-item', {
            key: w,
            staticClass: "sec-item",
            attrs: {
              "name": item4.menuName ? item4.menuName : ''
            },
            nativeOn: {
              "click": function($event) {
                _vm.getMenu(item4)
              }
            }
          }, [(item4.rightTag === _vm.tag && item4.menuUrl) ? _c('router-link', {
            attrs: {
              "to": {
                path: _vm.getRouterLinkUrl(item4.menuUrl)
              }
            },
            nativeOn: {
              "click": function($event) {
                _vm.useClickEvent(item4)
              }
            }
          }, [_c('span', {
            staticClass: "sub-text",
            attrs: {
              "title": _vm.lang === 'EN' ? item4.menuName : item4.menuEnName
            }
          }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item4.menuName : item4.menuEnName))])]) : (item4.systemUrl && item4.menuUrl && item4.rightTag !== _vm.tag) ? _c('a', {
            attrs: {
              "href": "javascript:;",
              "target": "_self"
            },
            on: {
              "click": function($event) {
                _vm.handleOtherRegin(item4.systemUrl + item4.menuUrl, item4)
              }
            }
          }, [_c('span', {
            staticClass: "sub-text",
            attrs: {
              "title": _vm.lang === 'EN' ? item4.menuName : item4.menuEnName
            }
          }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item4.menuName : item4.menuEnName))])]) : _c('span', {
            staticClass: "sub-text",
            attrs: {
              "title": _vm.lang === 'EN' ? item4.menuName : item4.menuEnName
            },
            on: {
              "click": function($event) {
                _vm.useClickEvent(item4)
              }
            }
          }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item4.menuName : item4.menuEnName))])], 1)
        })) : _c('t-menu-item', {
          key: z,
          staticClass: "sec-item",
          attrs: {
            "name": item3.menuName ? item3.menuName : ''
          },
          nativeOn: {
            "click": function($event) {
              _vm.getMenu(item3)
            }
          }
        }, [(item3.rightTag === _vm.tag && item3.menuUrl) ? _c('router-link', {
          attrs: {
            "to": {
              path: _vm.getRouterLinkUrl(item3.menuUrl)
            }
          },
          nativeOn: {
            "click": function($event) {
              _vm.useClickEvent(item3)
            }
          }
        }, [_c('span', {
          staticClass: "sub-text",
          attrs: {
            "title": _vm.lang === 'EN' ? item3.menuName : item3.menuEnName
          },
          on: {
            "click": function($event) {
              _vm.useClickEvent(item3)
            }
          }
        }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item3.menuName : item3.menuEnName))])]) : (item3.systemUrl && item3.menuUrl && item3.rightTag !== _vm.tag) ? _c('a', {
          attrs: {
            "href": "javascript:;",
            "target": "_self"
          },
          on: {
            "click": function($event) {
              _vm.handleOtherRegin(item3.systemUrl + item3.menuUrl, item3)
            }
          }
        }, [_c('span', {
          staticClass: "sub-text",
          attrs: {
            "title": _vm.lang === 'EN' ? item3.menuName : item3.menuEnName
          }
        }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item3.menuName : item3.menuEnName))])]) : _c('span', {
          staticClass: "sub-text",
          attrs: {
            "title": _vm.lang === 'EN' ? item3.menuName : item3.menuEnName
          },
          on: {
            "click": function($event) {
              _vm.useClickEvent(item3)
            }
          }
        }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item3.menuName : item3.menuEnName))])], 1)]
      })], 2) : _c('t-menu-item', {
        attrs: {
          "name": item2.menuName ? item2.menuName : ''
        }
      }, [(item2.rightTag === _vm.tag && item2.menuUrl) ? _c('router-link', {
        attrs: {
          "to": {
            path: _vm.getRouterLinkUrl(item2.menuUrl)
          }
        },
        nativeOn: {
          "click": function($event) {
            _vm.useClickEvent(item2)
          }
        }
      }, [_c('span', {
        staticClass: "sub-text",
        attrs: {
          "title": _vm.lang === 'EN' ? item2.menuName : item2.menuEnName
        }
      }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item2.menuName : item2.menuEnName))])]) : (item2.systemUrl && item2.menuUrl && item2.rightTag !== _vm.tag) ? _c('a', {
        attrs: {
          "href": "javascript:;",
          "target": "_self"
        },
        on: {
          "click": function($event) {
            _vm.handleOtherRegin(item2.systemUrl + item2.menuUrl, _vm.item)
          }
        }
      }, [_c('span', {
        staticClass: "sub-text",
        attrs: {
          "title": _vm.lang === 'EN' ? item2.menuName : item2.menuEnName
        }
      }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item2.menuName : item2.menuEnName))])]) : _c('span', {
        staticClass: "sub-text",
        attrs: {
          "title": _vm.lang === 'EN' ? item2.menuName : item2.menuEnName
        },
        on: {
          "click": function($event) {
            _vm.useClickEvent(item2)
          }
        }
      }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item2.menuName : item2.menuEnName))])], 1)]
    })], 2) : _c('t-menu-item', {
      attrs: {
        "name": item1.menuName ? item1.menuName : ''
      }
    }, [(item1.menuIcon) ? _c('t-icon', {
      attrs: {
        "type": item1.menuIcon
      }
    }) : _c('t-avatar', {
      attrs: {
        "size": "sm",
        "bg-state": "success",
        "text": item1.rightTag,
        "dot": false
      }
    }), _vm._v(" "), (item1.rightTag === _vm.tag && item1.menuUrl) ? _c('router-link', {
      attrs: {
        "to": {
          path: _vm.getRouterLinkUrl(item1.menuUrl)
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.useClickEvent(item1)
        }
      }
    }, [_c('span', {
      staticClass: "sub-text",
      attrs: {
        "title": _vm.lang === 'EN' ? item1.menuName : item1.menuEnName
      }
    }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item1.menuName : item1.menuEnName))])]) : (item1.systemUrl && item1.menuUrl && item1.rightTag !== _vm.tag) ? _c('a', {
      attrs: {
        "href": "javascript:;",
        "target": "_self"
      },
      on: {
        "click": function($event) {
          _vm.handleOtherRegin(item1.systemUrl + item1.menuUrl, item1)
        }
      }
    }, [_c('span', {
      staticClass: "sub-text",
      attrs: {
        "title": _vm.lang === 'EN' ? item1.menuName : item1.menuEnName
      },
      on: {
        "click": function($event) {
          _vm.useClickEvent(item1)
        }
      }
    }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item1.menuName : item1.menuEnName))])]) : _c('span', {
      staticClass: "sub-text",
      attrs: {
        "title": _vm.lang === 'EN' ? item1.menuName : item1.menuEnName
      },
      on: {
        "click": function($event) {
          _vm.useClickEvent(item1)
        }
      }
    }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item1.menuName : item1.menuEnName))])], 1)]
  })], 2)])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    class: ['layout-content', 'layout-delete-dot', {
      'hidenMenu': _vm.showMenuHead !== '1' && _vm.showMenuHead !== '3'
    }]
  }, [(_vm.showMenuHead === '1' || _vm.showMenuHead === '2') ? _c('div', {
    staticClass: "layout-nav navbar navbar-expand-lg bg-white align-items-center layout-nav--top"
  }, [_c('div', {
    staticClass: "row nav-row"
  }, [_c('div', {
    staticClass: "col col-1 nav-col"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showMenu),
      expression: "!showMenu"
    }],
    staticClass: "d-xm-block thumb-icon",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('t-icon', {
    staticClass: "text-xxl text-black",
    attrs: {
      "type": "menu"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openOrClose($event)
      }
    }
  })], 1), _vm._v(" "), _vm._t("frame-nav-left")], 2), _vm._v(" "), _c('div', {
    staticClass: "col col-11 nav-col nav-col--right"
  }, [_vm._t("frame-nav", [_c('t-menu', {
    staticClass: "menu-span",
    attrs: {
      "mode": "horizontal",
      "type": "light"
    },
    on: {
      "on-select": _vm.handleNavSelect
    }
  }, [_vm._l((_vm.navs), function(item, x) {
    return [(item.children) ? _c('t-submenu', {
      attrs: {
        "name": x ? x : ''
      }
    }, [_c('template', {
      slot: "title"
    }, [(item.icon) ? _c('t-icon', {
      attrs: {
        "type": item.icon
      }
    }) : _vm._e(), _vm._v(" "), (item.name) ? _c('span', {
      staticClass: "sub-text"
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()], 1), _vm._v(" "), _vm._l((item.children), function(item1, index) {
      return _c('t-menu-item', {
        key: index + 'item',
        attrs: {
          "name": x + '' + index
        }
      }, [(item1.icon) ? _c('t-icon', {
        attrs: {
          "type": item1.icon
        }
      }) : _vm._e(), _vm._v(" "), (item1.name) ? _c('span', {
        staticClass: "sub-text"
      }, [_vm._v(_vm._s(item1.name))]) : _vm._e()], 1)
    })], 2) : _c('t-menu-item', {
      attrs: {
        "name": x ? x : ''
      }
    }, [(x == '0') ? _c('span', [_c('t-icon', {
      attrs: {
        "type": "clock"
      }
    }), _c('font', {
      attrs: {
        "color": "#0085D0"
      }
    }, [_vm._v("HK")]), _vm._v("  " + _vm._s(_vm.formRight.HKTime) + "   \n                                    ")], 1) : _vm._e(), _vm._v(" "), (item.icon === 'bell' && _vm.count) ? _c('t-badge', {
      attrs: {
        "dot": "",
        "state": "danger"
      }
    }, [_c('span', {
      on: {
        "click": _vm.showSlipbox
      }
    }, [(item.icon) ? _c('t-icon', {
      attrs: {
        "type": item.icon
      }
    }) : _vm._e(), _vm._v(" "), (item.name) ? _c('span', {
      staticClass: "sub-text"
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()], 1)]) : (item.icon === 'bell') ? [_c('span', {
      on: {
        "click": _vm.showSlipbox
      }
    }, [(item.icon) ? _c('t-icon', {
      attrs: {
        "type": item.icon
      }
    }) : _vm._e(), _vm._v(" "), (item.name) ? _c('span', {
      staticClass: "sub-text"
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()], 1)] : [(item.handleType && item.handleType === 'logout') ? _c('a', {
      attrs: {
        "href": "javascript:;",
        "target": "_self"
      },
      on: {
        "click": function($event) {
          _vm.handleLogout(item)
        }
      }
    }, [(item.icon) ? _c('t-icon', {
      attrs: {
        "type": item.icon
      }
    }) : _vm._e(), _vm._v(" "), (item.name) ? _c('span', {
      staticClass: "sub-text"
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()], 1) : _c('span', [_c('t-dropdown', [_c('t-badge', {
      staticClass: "ml-4",
      staticStyle: {
        "margin-left": "0!important"
      }
    }, [(item.icon) ? _c('t-icon', {
      attrs: {
        "type": item.icon
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "80px",
        "overflow": "hidden"
      }
    }, [_vm._v(_vm._s(_vm.formRight.staffName))]), _vm._v(" "), _c('t-icon', {
      attrs: {
        "type": "arrow-down-drop",
        "size": "20"
      }
    })], 1), _vm._v(" "), _c('t-dropdown-menu', {
      staticClass: "cl-frame-dropdown",
      attrs: {
        "slot": "list"
      },
      slot: "list"
    }, [_c('t-dropdown-item', {
      on: {
        "on-click": function($event) {
          _vm.toPersonalInfo()
        }
      }
    }, [_c('t-icon', {
      attrs: {
        "type": "account-circle"
      }
    }), _vm._v(" "), _vm._v("\n                                                " + _vm._s(_vm.$t('frame.personalTitle')) + "\n                                            ")], 1), _vm._v(" "), _c('t-dropdown-item', {
      on: {
        "on-click": function($event) {
          _vm.toChangePWD()
        }
      }
    }, [_c('t-icon', {
      attrs: {
        "type": "lock-unlocked"
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.$t('frame.change_psd')) + "\n                                            ")], 1)], 1)], 1)], 1)]], 2)]
  })], 2)]), _vm._v(" "), _c('t-button', {
    staticClass: "btn-lang",
    attrs: {
      "type": "outline-secondary",
      "size": "sm"
    },
    domProps: {
      "textContent": _vm._s(_vm.lang === 'ZH' ? '中' : _vm.lang)
    },
    on: {
      "click": _vm.handleChangeLang
    }
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "clickout-side",
      rawName: "v-clickout-side",
      value: (_vm.handleClickoutSide),
      expression: "handleClickoutSide"
    }],
    class: _vm.slipbox__container
  }, [_c('div', {
    staticClass: "slipbox__content",
    class: [{
      'close': _vm.hideSlip
    }]
  }, [_c('div', {
    staticClass: "slipbox__close",
    on: {
      "click": _vm.hideSlipbox
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;",
      "target": "_self"
    }
  }, [_c('t-icon', {
    attrs: {
      "type": "close"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "slipbox__body"
  }, [_vm._t("slipbox-body", [_c('t-tabs', {
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, [_c('t-tab-panel', {
    attrs: {
      "label": _vm.$t('frame.sysInform'),
      "name": "tab-1"
    }
  }, [_vm._l((_vm.notices), function(item, index) {
    return _c('div', {
      staticClass: "notice-wrap",
      class: {
        'notice-active': _vm.isActive === index
      },
      on: {
        "click": function($event) {
          _vm.handleNoticeClick(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "nw-l"
    }, [_c('t-tag', {
      attrs: {
        "state": "info"
      }
    }, [_vm._v("info")])], 1), _vm._v(" "), _c('span', {
      staticClass: "nw-r"
    }, [_c('p', {
      staticClass: "nw-r-title"
    }, [_vm._v(_vm._s(item.bulletinTitle))]), _vm._v(" "), _c('p', {
      staticClass: "nw-r-time"
    }, [_vm._v(_vm._s(_vm.$t('frame.expiryDate')) + "：" + _vm._s(_vm._f("format")(item.activeTime)) + " " + _vm._s(_vm.$t('frame.to')) + " " + _vm._s(_vm._f("format")(item.inactiveTime)))])])])
  }), _vm._v(" "), (_vm.notices != null && _vm.notices.length > 0) ? _c('p', {
    staticClass: "notice__loading"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;",
      "target": "_self"
    },
    on: {
      "click": _vm.loadingMore
    }
  }, [_vm._v(_vm._s(_vm.$t('frame.loadingMore')))])]) : _vm._e()], 2)], 1)])], 2)])]), _vm._v(" "), _c('div', {
    class: [{
      'layout-main': _vm.showMenuHead !== '4'
    }, {
      'hidenNavTop': _vm.showMenuHead === '5'
    }, {
      'showMoreNav': _vm.showMenuHead === '4'
    }]
  }, [_c('div', {
    staticClass: "layout-main--content"
  }, [(_vm.breadcrumbArr && _vm.showMenuHead !== '4' && _vm.showMenuHead !== '5') ? _c('div', {
    staticClass: "bread-crumbs cmi-bread-crumbs-wrap"
  }, [_c('div', {
    staticClass: "row ml-0 mr-0"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-0"
  }, [_c('div', {
    staticClass: "breadcrumbs"
  }, [_vm._l((_vm.breadcrumbArr), function(item, $idx) {
    return [(item.rightTag === _vm.tag && $idx > 0 && $idx <= _vm.breadcrumbArr.length - 2 && item.menuUrl) ? _c('router-link', {
      staticClass: "canclick",
      attrs: {
        "to": {
          path: _vm.getRouterLinkUrl(item.menuUrl)
        }
      }
    }, [_c('span', [_vm._v(" " + _vm._s(_vm.lang === 'EN' ? item.menuName : item.menuEnName))]), _vm._v(" "), ($idx <= _vm.breadcrumbArr.length - 2) ? _c('span', [_vm._v(">")]) : _vm._e()]) : ($idx > 0 && $idx <= _vm.breadcrumbArr.length - 2 && item.menuUrl) ? _c('a', {
      key: $idx,
      staticClass: "canclick",
      on: {
        "click": function($event) {
          ($idx === _vm.breadcrumbArr.length - 1) && item.menuUrl ? '' : _vm.changeToPage(item.menuUrl)
        }
      }
    }, [_c('span', [_vm._v(" " + _vm._s(_vm.lang === 'EN' ? item.menuName : item.menuEnName))]), _vm._v(" "), ($idx <= _vm.breadcrumbArr.length - 2) ? _c('span', [_vm._v(">")]) : _vm._e()]) : _c('a', {
      key: $idx,
      staticClass: "unclick",
      on: {
        "click": function($event) {
          ($idx === _vm.breadcrumbArr.length - 1) && item.menuUrl ? '' : _vm.changeToPage(item.menuUrl)
        }
      }
    }, [_c('span', [_vm._v(" " + _vm._s(_vm.lang === 'EN' ? item.menuName : item.menuEnName))]), _vm._v(" "), ($idx <= _vm.breadcrumbArr.length - 2) ? _c('span', [_vm._v(">")]) : _vm._e()])]
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.showMenuHead === '4' && !_vm.isIframe) ? _c('div', {
    staticClass: "bg-white pt-10"
  }, [_c('div', {
    staticClass: "customer-tt-title pl-10"
  }, [(_vm.mpType === '1') ? _c('span', {
    staticClass: "eipBread"
  }, [_vm._v("\n                            " + _vm._s(_vm.lang === 'EN' ? _vm.staffMpMenu.mpNamecn : _vm.staffMpMenu.mpNameus) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.mpType === '2') ? _c('span', {
    staticClass: "eipBread"
  }, [_vm._v("\n                            " + _vm._s(_vm.staffMpMenuName) + "\n                        ")]) : _vm._e()]), _vm._v(" "), (_vm.mpType === '1') ? _c('div', {
    class: {
      'customer-tt-table': true,
      'customer-tt-table-angural-width': _vm.mpTreeData && _vm.mpTreeData.length && _vm.mpTreeData.length > 7 && _vm.lang === 'EN',
        'customer-tt-table-angural-width-en': _vm.mpTreeData && _vm.mpTreeData.length && _vm.mpTreeData.length > 5 && _vm.lang !== 'EN',
        'customer-tt-table-onlyone': _vm.mpTreeData && _vm.mpTreeData.length && _vm.mpTreeData.length === 1
    }
  }, [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.mpTreeData), function(staffMenu) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.changeStaffMpMenu(staffMenu.systemUrl, staffMenu.menuUrl)
        }
      }
    }, [_c('a', {
      class: {
        'z-crttab': staffMenu.menuUrl === _vm.staffMpMenuUrl
      }
    }, [_vm._v(_vm._s(_vm.lang === 'EN' ? staffMenu.menuName !== null && staffMenu.menuName !== '' ? staffMenu.menuName : staffMenu.menuEnName : staffMenu.menuEnName))])])
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mpType === '2' && _vm.translateMusterMenuList && _vm.translateMusterMenuList.length &&
    (_vm.showMenuHead === '1' || _vm.showMenuHead === '4' || _vm.showMenuHead === '2' || _vm.showMenuHead === '3')) ? _c('div', {
    ref: "musterMenuListId",
    staticClass: "crm-wrapper",
    staticStyle: {
      "padding": "0 10px 15px!important"
    }
  }, [(_vm.mpType === '2' && _vm.translateMusterMenuList && _vm.translateMusterMenuList.length) ? _c('div', {
    staticClass: "customer-tt-table-low"
  }, [_c('ul', {
    staticClass: "menu_eip"
  }, [_vm._l((_vm.translateMusterMenuList), function(item, index) {
    return [(!item.childMenu || item.childMenu.length < 0) ? _c('li', {
      key: item.menuId,
      class: {
        'z-crttab': item.url === _vm.$route.path
      },
      on: {
        "click": function($event) {
          _vm.selectMpMenu(item.url + ';' + item.url,
            _vm.lang === 'EN' ? ' > ' + item.menuName : ' > ' + item.menuEnName,
            _vm.authMenuList.indexOf(item.menuId) <= -1)
        }
      }
    }, [_c('svg', {
      staticClass: "icon glyph-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": item.menuIcon
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "glyph-name",
      style: ({
        fontSize: _vm.lang === 'EN' ? '16px' : '12px'
      })
    }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item.menuName : item.menuEnName))]), _vm._v(" "), _c('i', {
      staticClass: "glygh-line"
    })]) : _c('li', {
      key: item.menuId,
      class: {
        'z-crttab': item.menuUrl === _vm.$route.path
      }
    }, [_c('t-dropdown', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placement": "bottom"
      },
      on: {
        "on-visible-change": _vm.dropDownIconChange
      }
    }, [_c('div', {
      staticClass: "menu__submenu-title"
    }, [_c('svg', {
      staticClass: "icon glyph-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": item.menuIcon
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "glyph-name",
      style: ({
        fontSize: _vm.lang === 'EN' ? '16px' : '12px'
      })
    }, [_vm._v(_vm._s(_vm.lang === 'EN' ? item.menuName : item.menuEnName))]), _vm._v(" "), _c('i', {
      staticClass: "glygh-line"
    })]), _vm._v(" "), _c('t-dropdown-menu', {
      staticClass: "cl-frame-dropdown",
      attrs: {
        "slot": "list"
      },
      slot: "list"
    }, _vm._l((item.childMenu), function(staffMenu) {
      return _c('t-dropdown-item', {
        key: staffMenu.menuUrl,
        attrs: {
          "selected": staffMenu.url === _vm.$route.path,
          "divided": "",
          "name": staffMenu.url + ';' + staffMenu.url,
          "value": staffMenu.url,
          "disabled": _vm.checkMusterMenuAuth(staffMenu.menuId)
        },
        on: {
          "on-click": function($event) {
            _vm.selectMpMenu(staffMenu.url + ';' + staffMenu.url,
              _vm.lang === 'EN' ? ' > ' + item.menuName + ' > ' + staffMenu.menuName :
              ' > ' + item.menuEnName + ' > ' + staffMenu.menuEnName, _vm.checkMusterMenuAuth(staffMenu.menuId))
          }
        }
      }, [_vm._v("\n                                                " + _vm._s(_vm.lang === 'EN' ? staffMenu.menuName : staffMenu.menuEnName) + "\n                                            ")])
    }))], 1)], 1)]
  })], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isIframeContent) ? _c('router-view', {
    staticClass: "pt-10"
  }) : _vm._e(), _vm._v(" "), (_vm.isIframeContent) ? _c('iframe', {
    staticClass: "pt-10",
    attrs: {
      "width": _vm.clientWidth,
      "height": "1000",
      "src": _vm.iframeUrl,
      "frameborder": "0"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMenuHead !== '4' && _vm.showMenuHead !== '5') ? _c('div', {
    staticClass: "pager-footer"
  }, [_c('p', [_vm._v(_vm._s(_vm.pagerFooter))])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "slide-wrap-content",
    class: [{
      'slideWrapClose': _vm.hideSlideWrapSlip
    }]
  }, [_c('t-icon', {
    staticClass: "icon-close mr-5 mt-3",
    attrs: {
      "type": "close",
      "size": "36"
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleClickClose($event)
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55d4b9b1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frame/frame.vue
// module id = 88
// module chunks = 0